import React,{Component} from 'react';
import './SigninPopup.css'
import {Link,NavLink} from 'react-router-dom'
class SigninPopup extends Component{
    
      render() {
        return (
          <div className="SigninPopup">
            <div className="innerpopup">
                <div className="deeppopup">
                 <span className="loveThis">Love this dress?</span>
                 <span className="suggestion">Sign in to save.</span>
                 <NavLink to="/signup">
                 <span className="signin">SIGN IN</span>
                 </NavLink>
            </div>
            </div>
          </div>
        );
      }
    }
export default SigninPopup;